<template>
  <div>

    <!-- Post -->
    <div class="mt-2 post">
      <div class="row">

        <!-- Author -->
        <div class="col-12 d-flex mt-1 mb-3" v-if="post.author" @click="routeToPostOnclick && goToViewPost()">
          <div>
            <div style="display: flex;gap: 1em;align-items: center;">
              <div>
                <profile-image v-if="post.author.profileImage" :file-id="post.author.profileImage" :image-style="profileImageStyle">
                </profile-image>
                <img v-else :src="defaultImage" alt="" srcset="" :style="profileImageStyle">
              </div>
              <div style="line-height: 1em;">
                <div>
                  <span>
                    <strong>
                      {{ post.author.firstName }} {{ post.author.lastName }}
                    </strong>
                  </span>
                </div>
                <div>
                  <small>
                    <strong style="color: #9c9c9c;">
                      {{ _getFormattedDate(new Date(post.createdAt).getTime(), 'ago') }}
                    </strong>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Post title and description  -->
        <div class="col-12" v-if="type == 'post' && post.title" @click="routeToPostOnclick && goToViewPost()">
          <h5 style="font-size: 1rem;font-weight: 600;" class="mb-2">{{ post.title }}</h5>
        </div>
        <div class="col-12 mb-2" :class="type == 'post' ? 'post-description' : 'reply-description'">
          {{ post.description }}
        </div>

        <!-- Attachments -->
        <div class="col-12" v-if="post.attachments && post.attachments.length > 0" :class="isTouchScreenDevice ? 'p-0' : 'p-4'">
          <carousel style="width: 100%" :per-page="1" :navigationEnabled="!isTouchScreenDevice">
            <slide v-for="(attachment, index) in  post.attachments " :key="attachment.fileId">
              <div v-if="!attachment.mediaType" style="border-radius: 1em; overflow:hidden;height: 20rem;background: var(--dark);display: grid;place-items: center;" @click="viewFile($event, attachment)">
                <dynamic-image-background v-if="attachment.type.indexOf('image') > -1" :file-id="attachment.fileId" style="width: 100%">
                </dynamic-image-background>
                <dynamic-video v-if="attachment.type.includes('video/')" :file-id="attachment.fileId" controlsList="nodownload" :options="{ controls: false }" />
              </div>
            </slide>
          </carousel>
        </div>

        <!-- Actions -->
        <div class="col-12 post-footer">
          <div style="display: flex;font-weight: 600;color: #959595;">
            <div class="pr-3" style="width: 4em;">
              <span @click="likeOrDislikePost($event)">
                <i class="fa-heart pr-1" :class="liked ? 'fas text-danger' : 'far'"></i>
                <span>
                  <span>{{ post.likes.length }}</span>
                </span>
              </span>
            </div>
            <div style="width: 4em;">
              <i class="far fa-comment pr-1"></i>
              <span>
                <span>{{ post.replyCount }}</span>
              </span>
            </div>
            <!--           <div style="width: 3.5em;" @click="editPost($event)" v-if="post.author._id == this.user._id">
      <i class="far fa-edit pr-1"></i>
    </div>
    <div style="width: 4em;" @click="deletePost($event)" v-if="post.author._id == this.user._id">
      <i class="far fa-trash-alt  text-danger pr-1"></i>
    </div>
    <div style="margin-left: auto;" v-if="post.edited">
      {{ $t("message.forum7") }}
    </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- View file modal-->
    <modal :show.sync="fileToView" headerClasses="d-none" class="view-file-modal" footerClasses="d-none" modalContentClasses="write-post-modal-content" :showClose="false" :animationDuration="250">

      <div class="view-file-header " v-show="showOptions">
        <i class="now-ui-icons ui-1_simple-remove close-icon" @click="closeModal"></i>
      </div>

      <div v-if="fileToView" class="file-wrapper" @click="showOptions = !showOptions">
        <dynamic-image v-if="fileToView.type.indexOf('image') > -1" :file-id="fileToView.fileId" image-id="signature-img" image-style="max-height: 100%;"></dynamic-image>

        <dynamic-video v-if="fileToView.type.includes('video/')" :file-id="fileToView.fileId" controlsList="nodownload" :options="{ controls: false }" />
      </div>

    </modal>
  </div>
</template>

<script>
export default {
  name: "forum-post",
  props: {
    post: {
      type: Object,
    },
    type: {
      type: String,
    },
    routeToPostOnclick: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      defaultImage: require("@/assets/img/proAvatar.png"),
      profileImageStyle:
        "width: 2.5rem;height: 2.5rem; border-radius: 50%; margin: auto;",
      fileToView: null,
      showOptions: true,
      videoMediaStatus: {},
    };
  },

  methods: {
    async likeOrDislikePost(event) {
      event.stopPropagation();
      try {
        let response = await this.$store.dispatch("toggleLike", {
          userId: this.user._id,
          postId: this.post._id,
        });
        this.post.likes = response.likes;
      } catch (error) {
        console.log(error);
      }
    },
    deletePost(event) {
      event.stopPropagation();
      swal
        .fire({
          title: this.$t("message.telemed4"),
          confirmButtonText: this.$t("message.filecard5"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.filecard6"),
        })
        .then(async (result) => {
          if (result && result.value) {
            try {
              await this.$store.dispatch("deletePost", {
                postId: this.post._id,
              });
              swal.fire({
                title: this.$t("message.Success!"),
                text: this.$t("message.forum8"),
                type: "success",
                timer: 3000,
                showCloseButton: true,
              });
              this.$emit("post-deleted");
            } catch (error) {
              console.log(error);
              swal.fire({
                title: this.$t("message.bookings4") + "!",
                text: this.$t("message.forum9"),
                type: "error",
                timer: 3000,
                showCloseButton: true,
              });
            }
          }
        });
    },
    editPost(event) {
      event.stopPropagation();
      this.$emit("edit-post", this.post);
    },
    async goToViewPost() {
      let forumPostCache = structuredClone(this.$store.state.forumPostCache);
      forumPostCache[this.post._id] = this.post;
      this.$store.commit("setState", {
        stateName: "forumPostCache",
        stateValue: forumPostCache,
      });
      this.$store.state.postRouteStack.push(this.post._id);
      this.$router.push("/viewforumpost/" + this.post._id);
    },
    viewFile(event, file) {
      event.stopPropagation();
      this.fileToView = file;
      this.showOptions = true;
    },
    closeModal() {
      this.fileToView = null;
    },
  },
  computed: {
    liked() {
      return this.post.likes.includes(this.user._id);
    },
  },
};
</script>

<style scoped>
/deep/.post .card-body {
  height: 12rem;
}

/deep/.post .card-body {
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/.post .card:not(.add-meal) hr {
  display: none;
}

.post {
  border-bottom: 1px solid #dedede;
  padding-left: 15px;
  padding-right: 15px;
}

/* .post-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.1em;
} */

.reply-description {
  word-break: break-word;
}

.post-footer {
  margin-bottom: 1em;
  margin-top: 1em;
}

/deep/ .VueCarousel-slide {
  padding-left: 1rem;
  padding-right: 1rem;
}

/deep/ .view-file-modal .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  height: 100%;
  padding-bottom: 0px;
}

/deep/ .view-file-modal .modal-dialog {
  margin: 0;
}

/deep/ .view-file-modal .modal-content {
  background-color: black;
}

/deep/ .view-file-modal .file-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .view-file-modal .close-icon {
  font-weight: 900;
  font-size: 1.2em;
  color: #a5a5a5;
  padding: 1rem;
}

/deep/ .view-file-modal .view-file-header {
  position: absolute;
  z-index: 1;
  background: #343a4080;
  width: 100%;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}
</style>
